import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { api } from '../../../app/Api/ApiSlice'
import Loader from '../../../components/Loader'

const EditShelf = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { storeName } = useParams() // assuming your route has /stores/:storeName
    const { shelf } = location.state || {}

    const [localShelf, setLocalShelf] = useState({ name: '', description: '' })
    const [updating, setUpdating] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    // Initialize local state from location.state
    useEffect(() => {
        if (shelf) {
            setLocalShelf({ name: shelf.name || '', description: shelf.description || '' })
            setIsLoading(false)
        } else {
            toast.error("Shelf data not found")
            navigate(-1) // go back if no shelf provided
        }
    }, [shelf, navigate])

    const handleUpdateShelf = async (e) => {
        e.preventDefault()
        if (!localShelf.name.trim()) return toast.error("Shelf name cannot be empty")
        setUpdating(true)

        try {
            const response = await api.put(
                `/stores/${storeName}/manage/shelves/${shelf._id}`,
                { name: localShelf.name, description: localShelf.description }
            )
            if (response && response.data) {
                toast.success("Shelf updated successfully")
                navigate(`/b/manage/${storeName}/shelves`)
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update shelf")
        } finally {
            setUpdating(false)
        }
    }

    if (isLoading) return <Loader />

    return (
        <div className="edit-shelf-container">
            <h2>Edit Shelf</h2>
            <form onSubmit={handleUpdateShelf}>
                <label htmlFor="name">Name</label>
                <input
                    type="text"
                    id="name"
                    value={localShelf.name}
                    onChange={(e) => setLocalShelf({ ...localShelf, name: e.target.value })}
                    required
                />

                <label htmlFor="description">Description</label>
                <input
                    type="text"
                    id="description"
                    value={localShelf.description}
                    onChange={(e) => setLocalShelf({ ...localShelf, description: e.target.value })}
                />

                <button type="submit">{updating ? "Updating..." : "Save Changes"}</button>
            </form>
        </div>
    )
}

export default EditShelf